module.exports = {
  /* 01.General */
  "chat.end":"Restart your chat conversation",
  "chat.endall":"End Chat",
  "chat.cancel":"Cancel",
  "chat.cookie":"This digital assistant uses cookies to ensure you get the best experience",
  "chat.learn":"Learn more",
  "chat.minimize":"Minimize",
  "chat.hide":"Close",
  "chat.hidebot.text":"Close will make the avatar disappear for 15 minutes",
  "chat.hidebot":"Close (Hide) Avatar",
  "chat.restart":"Restart",
  "switch.language":"Switch Language",
  "switch.property":"Switch Property",
  "restart.converstation":"Restart Conversation",
  "chat.endtext":"Are you sure you want to end the current chat?",
  "check.availabity":"Check Availability",
  "check.availabity.submit":"Submit",
  "check.availabity.cancel":"Cancel",
  "check.availabity.adults":"Adults ",
  "check.availabity.children":"Children",
  "check.availabity.child.age":"Age - child",
  "feedback.leave":"Leave Feedback",
  "feedback.leave.message":"Leave Message",
};
